<template>
    <el-form ref="orgForm" class="apple_org" label-position="left" v-loading="editLoading" :model="formItem" :rules="rules" label-width="180px">
        <div class="create_list">
            <div class="create_title">所属广告系列组</div>
            <el-form-item label="所属广告系列组：" prop="org_id">
                <el-select
                    popper-class="select-option-long-text-wrap"
                    v-model="formItem.org_id"
                    ref="select_org_id"
                    filterable
                    reserve-keyword
                    @change="changeSelect('org_id',$event)"
                    :loading="remoteOrgLoading"
                    :disabled="isEdit"
                    class="width400"
                    placeholder="输入广告系列组 ID 或名称关键字搜索">
                    <el-option
                        v-for="item in orgList"
                        :key="item.value"
                        :label="item.label+'【'+item.value+'】'"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </div>
        <div class="create_list" v-if="!!formItem.org_id||isEdit">
            <div class="create_title">基础信息</div>
            <el-form-item label="推广的App：" prop="app_id" class="relative">
                <span v-if="!!formItem.app_id&&!isEdit" class="remove-app-btn" @click="removeApp">x</span>
                <el-input v-model="appInput" placeholder="请输入AppID或名称搜索查询" :readonly="!!formItem.app_id" :disabled="isEdit" @input="appInputChange" @keyup.enter.native.prevent.stop="searchApp" class="width400">
                    <el-button slot="append" type="primary" @click.stop="searchApp" class="ml10 width80" :loading="remoteAppLoading" :disabled="!!formItem.app_id||isEdit" plain>搜索</el-button>
                </el-input>
                <span class="ml20 text-color-gray font12px" v-if="!isEdit">搜索后若未显示需要的App，请检查该App是否已经与所属广告系列组绑定</span>

                <p class="mt6 text-color-error font12px" v-if="appErrTxt">{{appErrTxt}}</p>

                <el-popover
                    :value="appPopover"
                    placement="bottom-start"
                    width="400"
                    trigger="manual">
                    <span slot="reference" class="app-reference"></span>
                    <div class="app-search-list" >
                        <ul v-loading="remoteAppLoading" :style="{minHeight:remoteAppLoading?'50px':'10px'}">
                            <li class="pointer" v-for="item in appList" :key="item.value" @click="checkApp(item)">{{item.label}}【{{item.value}}】</li>
                            <li class="tac text-color-gray" v-if="appList.length<=0&&!remoteAppLoading">无符合产品</li>
                        </ul>
                    </div>
                </el-popover>


                <!--<el-select
                    popper-class="select-option-long-text-wrap"
                    v-model="formItem.app_id"
                    ref="select_app_id"
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="remoteAppMethod"
                    @change="changeSelect('app_id',$event)"
                    :loading="remoteAppLoading"
                    :disabled="isEdit"
                    class="width400"
                    no-data-text="无符合产品"
                    no-match-text="无符合产品"
                    placeholder="请输入完整的 AppID搜索查询">
                    <el-option
                        v-for="item in appList"
                        :key="item.value"
                        :label="item.label+'-'+item.value"
                        :value="item.value">
                    </el-option>
                </el-select>-->
            </el-form-item>

            <el-form-item label="广告投放位置：" prop="supply_source">
                <SupplyCard class="mt10" :options="supplySourceOptions" :loading="appEligibilityLoading" :disabled="isEdit" :value="formItem.supply_source" @change="changeSupplySource"/>
            </el-form-item>

            <el-form-item label="国家或地区：" prop="countries_or_regions">
                <el-tooltip placement="top" :disabled="!!formItem.app_id&&!!formItem.supply_source">
                    <div slot="content">
                        <span v-if="!formItem.app_id">请先选择App</span>
                        <span v-else>请先选择广告投放位置</span>
                    </div>
                    <el-select
                        v-model="formItem.countries_or_regions"
                        ref="select_countries_or_regions"
                        :disabled="!formItem.app_id||!formItem.supply_source"
                        filterable
                        multiple
                        reserve-keyword
                        class="width400"
                        placeholder="输入国家或地区名称搜索">
                        <el-option
                            v-for="item in countryList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-tooltip>
            </el-form-item>

            <el-form-item prop="daily_budget" class="relative">
                <span slot="label">
                    <el-tooltip placement="top">
                      <div slot="content" style="max-width: 300px;">
                          <p class="mb10">每日预算是你希望在一个月内每天花费在广告系列上的平均金额。</p>
                          <p class="mb10">你的每月支出不会超过每日预算乘以一个日历月的平均天数。在有机会获得更多下载次数的日子里，你的支出可能会超出每日预算。</p>
                          <p class="mb10">你的广告系列会持续根据每日预算金额进行每月支出，除非你暂停、移除广告系列或设置结束日期。如果你设置了结束日期，则你支出的费用不会超过广告系列总天数乘以每日预算。</p>
                          <p class="mb10">你可以随时调整每日预算。</p>
                      </div>
                      <span class="tal">每日预算 <i class="el-icon-question pointer" style="text-indent: 0;"></i> ：</span>
                    </el-tooltip>
                </span>
                <el-input v-model="formItem.daily_budget" @input="handleDailyBudgetInput" placeholder="请输入每日预算金额" class="width400"></el-input>
                <span class="normal-text ml10">{{orgConfig.currency}}</span>

                <span v-if="+formItem.daily_budget>10000&&+formItem.daily_budget>+avgCampaignDailyBudget" class="daily-budget-tips-text text-color-error font12px ml20">输入的每日预算大于等于 一万 {{orgConfig.currency}}，且超出账户平均每日预算 {{dailyBudgetDiff}} （{{dailyBudgetRate}}%），请核实！</span>
                <span v-else-if="+formItem.daily_budget>+avgCampaignDailyBudget&&avgCampaignDailyBudget>0" class="daily-budget-tips-text text-color-error font12px ml20">输入的每日预算超出账户平均每日预算 {{dailyBudgetDiff}} {{orgConfig.currency}}（{{dailyBudgetRate}}%），请核实！</span>
                <span v-else-if="+formItem.daily_budget>10000" class="daily-budget-tips-text text-color-error font12px ml20">输入的每日预算大于等于 一万 {{orgConfig.currency}}，请核实！</span>

            </el-form-item>

            <el-form-item label="广告系列名称：" prop="campaign_name">
                <el-input v-model="formItem.campaign_name" :maxlength="200" placeholder="最多可输入 200 个字，不可输入特殊符号" class="width400"></el-input>
                <span class="normal-text ml10">{{formItem.campaign_name.length}} / 200</span>
            </el-form-item>
        </div>

        <div class="create_list invoicing_options" v-if="!!formItem.org_id">
            <div class="create_title">投放时间</div>
            <el-form-item label=" 投放日期：" prop="time_zone" class="label-required">
                <el-radio-group v-model="startEndDateType">
                    <el-radio-button label="1">
                        <span class="inline-block" style="width:130px;">长期投放</span>
                    </el-radio-button>
                    <el-radio-button label="2">
                        <span class="inline-block" style="width:130px;">指定开始和结束日期</span>
                    </el-radio-button>
                </el-radio-group>
                <span class="font12px ml20 text-color-gray" v-if="formItem.time_zone=='Asia/Shanghai'">时区-上海</span>
                <span class="font12px ml20 text-color-gray" v-else-if="formItem.time_zone=='UTC'">时区-UTC</span>
                <!--<el-select v-model="formItem.time_zone" :disabled="isEdit" placeholder="请选择" class="ml10" style="width: 106px;" size="mini">-->
                    <!--<el-option label="时区-上海" value="Asia/Shanghai">时区-上海</el-option>-->
                    <!--<el-option label="时区-UTC" value="UTC">时区-UTC</el-option>-->
                <!--</el-select>-->
                <!--<span class="text-color-gray font12px ml10">您可按照选择的时区直接设置投放日期&时间，无需再次转化时区</span>-->
            </el-form-item>
            <el-form-item label="" prop="start_time">
                <span class="mr20 normal-text">开始日期：</span>
                <el-date-picker
                    :disabled="isEdit"
                    style="width: 136px;"
                    size="mini"
                    v-model="formItem.startDate"
                    :picker-options="startPickerOptions"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-time-picker
                    :disabled="isEdit"
                    class="ml10"
                    style="width: 130px;"
                    size="mini"
                    v-model="formItem.startTime"
                    value-format="HH:mm"
                    format="HH:mm"
                    :picker-options="{format:'HH:mm'}"
                    placeholder="选择时间">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="" prop="end_time" v-if="startEndDateType=='2'">
                <span class="mr20 normal-text">结束日期：</span>
                <el-date-picker
                    style="width: 136px;"
                    size="mini"
                    v-model="formItem.endDate"
                    :picker-options="endPickerOptions"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-time-picker
                    class="ml10"
                    style="width: 130px;"
                    size="mini"
                    v-model="formItem.endTime"
                    value-format="HH:mm"
                    format="HH:mm"
                    :picker-options="{format:'HH:mm'}"
                    placeholder="选择时间">
                </el-time-picker>
            </el-form-item>
        </div>

        <div class="create_list" v-if="!!formItem.org_id&&formItem.supply_source=='APPSTORE_SEARCH_RESULTS'&&!isEdit">
            <div class="create_title">关键词</div>
            <el-form-item label="添加否定关键词：" prop="negative_keyword">
                     <span slot="label">
                    <el-tooltip placement="top">
                      <div slot="content" style="max-width: 300px;">
                          <p class="mb10">否定关键词可防止你的广告在这些词的搜索结果中显示。</p>
                          <p class="mb10">例如，如果你添加“免费”作为否定关键词，则你的广告不会出现在使用“免费”这个词执行的搜索中。你添加的否定关键词仅适用于此广告组。在广告系列级别设置否定关键词，以将其应用于所有广告组。</p>
                      </div>
                      <span>添加否定关键词 <i class="el-icon-question"></i> :</span>
                    </el-tooltip>
                </span>

                <el-link type="primary" :underline="false" @click="showNegativeKeywordModal">点击添加</el-link>
                <span class="normal-text ml10">（已添加 {{formItem.negative_keyword.length}} 个广告系列否定关键词）</span>

                <span v-if="!isEdit" class="text-color-error pointer font12px ml20" @click="clearNegativeKeyword">清空</span>
            </el-form-item>
        </div>

        <div class="create_list invoicing_options" v-if="orgConfig.invoicing_options">
            <div class="create_title">结算信息</div>

            <el-form-item label="结算选项：" class="label-required">
                <el-radio-group value="1">
                    <el-radio-button label="1">
                        <span class="inline-block" style="width: 100px;">标准账单</span>
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="广告主或产品：" prop="client_name" class="label-required">
                <el-input v-model="formItem.client_name" placeholder="请输入广告主或产品" class="width400"></el-input>
            </el-form-item>
            <el-form-item label="订单号：" prop="order_number" class="label-required">
                <el-input v-model="formItem.order_number" placeholder="请输入订单号" class="width400"></el-input>
            </el-form-item>
            <el-form-item label="主要联系人姓名：" prop="buyer_name" class="label-required">
                <el-input v-model="formItem.buyer_name" placeholder="请输入主要联系人姓名" class="width400"></el-input>
            </el-form-item>
            <el-form-item label="主要联系人邮箱：" prop="buyer_email" class="label-required">
                <el-input v-model="formItem.buyer_email" placeholder="请输入主要联系人邮箱" class="width400"></el-input>
            </el-form-item>
            <el-form-item label="结算联系人邮箱：" prop="billing_contact_email" class="label-required">
                <el-input v-model="formItem.billing_contact_email" placeholder="请输入结算联系人邮箱" class="width400"></el-input>
            </el-form-item>
        </div>

        <NegativeKeywordModal
            ref="negativeKeywordModal"
            action-type="campaignAddNegativeKeyword"
            :action-rows="formItem.negative_keyword"
            :form-data="actionRowData"
            @save="saveNegativeKeyword"/>

        <el-dialog
            :title="null"
            :visible.sync="dialogVisible"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :show-close=false
            :destroy-on-close=true
            width="450px"
            custom-class="apple-dialog-err">
            <div>
                <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                <p class="tac text-color-error pt10 pb20">请勿刷新页面，刷新页面会导致无法及时收到最新结果</p>
            </div>
        </el-dialog>
    </el-form>
</template>
<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/marketManage/apple/index';
    import SupplyCard from '../components/supplyCard';
    import NegativeKeywordModal from '../keywords/modal/negativeKeywordModal';
    import {
        get_create_ad_err_html,
        get_err_info,
        get_flag_single_post_html,
        get_flag_suc_html,
        get_flag_single_err_html,
        get_flag_mul_err_html
    } from "../components/getFlagHtml.js";
    import {validEmoji} from '@/utils/validate'
    export default {
        name: 'CreateAdOrg',
        components:{
            SupplyCard,
            NegativeKeywordModal,
        },
        props: ['org'],
        data() {
            let _this = this;

            const campNameDailyBudget = (rule, value, callback) =>{
                /* 长期投放：仅设置开始日期 */
                if(+value<0.01){
                    callback(new Error('每日预算不可小于0.01'));
                }else{
                    callback();
                }
            };

            const campNameValid = async (rule, value, callback) =>{
                await API.getPromotionCampaignName({
                    org_id:_this.formItem.org_id,
                    campaign_name:_this.formItem.campaign_name,
                    campaign_id:_this.isEdit?_this.formItem.campaign_id:'',
                }).then(() => {
                    callback();
                },err=>{
                    callback(new Error(err.info||'校验不通过!'));
                });
            };

            const startTimeValid = (rule, value, callback) =>{
                /* 长期投放：仅设置开始日期 */
                if(!_this.formItem.startDate||!_this.formItem.startTime){
                    callback(new Error('请设置开始投放时间'));
                }else{
                    callback();
                }
            };

            const endTimeValid = (rule, value, callback) =>{
                if(_this.startEndDateType=='1'){
                    /* 长期投放：仅设置开始日期 */
                    callback();
                }else if(_this.startEndDateType=='2'){
                    /* 指定开始日期和结束日期 */
                    if(!_this.formItem.startDate||!_this.formItem.startTime){
                        callback(new Error('请设置开始投放时间'));
                    }else if(!_this.formItem.endDate||!_this.formItem.endTime){
                        callback(new Error('请设置结束投放时间'));
                    }if(new Date(_this.formItem.startDate+' '+_this.formItem.startTime).getTime()>=new Date(_this.formItem.endDate+' '+_this.formItem.endTime).getTime()){
                        callback(new Error('投放结束时间需要大于开始时间'));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            const invoiceValid = (rule, value, callback) =>{
                if(_this.orgConfig.invoicing_options){
                    let reg = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g;
                    if(!value){
                        callback(new Error('请输入内容'));
                    }else if(validEmoji(value)){
                        callback(new Error('不支持输入表情'));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };


            return {
                formItem:{
                    org_id:'',
                    app_id:'',
                    app_name:'',
                    supply_source:'',   //投放位置
                    countries_or_regions:[],   //国家或地区
                    daily_budget:'',   //每日预算
                    campaign_name:'',   //广告系列名称
                    time_zone:'',       //
                    negative_keyword:[],
                    client_name:'',     // 广告主或产品
                    order_number:'',     // 订单号
                    buyer_name:'',     // 主要联系人姓名
                    buyer_email:'',     // 主要联系人邮箱
                    billing_contact_email:'',     // 结算联系人邮箱
                    startTime:'00:00',
                    startDate:'',
                    endTime:'',
                    endDate:'',
                },
                orgList:[],
                remoteOrgLoading:false,
                appList:[],
                remoteAppLoading:false,
                startEndDateType:'1',   // 1长期 2-指定开始结束日期

                countryList:[],
                remoteCountryLoading:false,
                supplySourceOptions:[
                    {
                        title:'Today 标签',
                        name:'APPSTORE_TODAY_TAB',
                        desc:'在用户到访 App Store 寻找 app 时触达他们。你的广告将在首页上完整展示。',
                        disabled:true,
                        popTip:'请先选择APP',
                    },
                    {
                        title:'搜索标签',
                        name:'APPSTORE_SEARCH_TAB',
                        desc:'在用户搜索要下载的 app 前吸引他们。你的广告将展现在建议 app 列表的顶部。',
                        disabled:true,
                        popTip:'请先选择APP',
                    },
                    {
                        title:'搜索结果',
                        name:'APPSTORE_SEARCH_RESULTS',
                        desc:'在用户查找要下载的 app 时吸引他们。当用户搜索时，你的广告将展现在相关结果的顶部。',
                        disabled:true,
                        popTip:'请先选择APP',
                    },
                    {
                        title:'产品页面',
                        name:'APPSTORE_PRODUCT_PAGES_BROWSE',
                        desc:'在用户浏览 app 时吸引他们。你的广告将向滑动到相关产品页面底部的用户展示。位于“你可能还喜欢“列表的顶部。',
                        disabled:true,
                        popTip:'请先选择APP',
                    },
                ],
                appEligibility:{},
                appEligibilityLoading:false,
                avgCampaignDailyBudget:0,
                startPickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() < Date.now()-1000*60*60*24*2;
                    },
                },
                endPickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        let startDate = new Date(_this.formItem.startDate+' '+(_this.formItem.startTime||'00')+':00');
                        return time.getTime() < startDate.getTime();
                    },
                },

                oldSelectVal:{
                    org_id:'',
                    app_id:'',
                },
                rules:{
                    org_id:[
                        { required: true, message: '请选择所属广告系列组', trigger: 'change' },
                    ],
                    app_id:[
                        { required: true, message: '请搜索选择推广的App', trigger:'change'},
                    ],
                    supply_source:[
                        { required: true, message: '请选择广告投放位置', trigger: ['blur','change'] },
                    ],
                    countries_or_regions:[
                        { required: true, message: '请选择国家或地区', trigger: 'change' },
                    ],
                    daily_budget:[
                        { required: true, message: '请输入每日预算', trigger: 'blur' },
                        { validator: campNameDailyBudget, trigger: 'blur' },
                    ],
                    campaign_name:[
                        { required: true, message: '请选择广告系列名称', trigger: 'blur' },
                        { validator: campNameValid, trigger: 'blur' },
                    ],
                    // time_zone:[
                    //     { required: true, message: '请选择时区', trigger:  ['blur','change'] },
                    // ],
                    start_time:[
                        { validator: startTimeValid, trigger: 'blur' },
                    ],
                    end_time:[
                        { validator: endTimeValid, trigger: 'blur' },
                    ],
                    client_name:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                    order_number:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                    buyer_name:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                    buyer_email:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                    billing_contact_email:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                },
                orgConfig:{
                    currency:'',    // 货币
                    invoicing_options:null,     // 是否有结算选项
                },
                orgName:'',
                editLoading:false,
                dialogVisible: false,   //各种错误提示
                dialogTypeTitle: '',
                // apple_create_type: '',

                appInput:'',
                appErrTxt:'',
                appPopover:false,
            }
        },
        computed:{
            ...mapGetters(['name','email','apple_create_type','cur_tab_page']),
            actionRowData(){
                return {
                    org_id:this.formItem.org_id,
                    org_name:this.orgName,
                }
            },
            dailyBudgetRate(){
                let avgVal = +this.avgCampaignDailyBudget;
                let curVal = +this.formItem.daily_budget;
                if(avgVal==0) return 0;
                return curVal>avgVal?((curVal-avgVal)/avgVal*100).toFixed(2):'';
            },
            dailyBudgetDiff(){
                let diff = this.formItem.daily_budget-this.avgCampaignDailyBudget;
                return (diff).toFixed(2);
            },
            isEdit(){
                return this.apple_create_type=='editOrg';
            },
            // res_org_item(){
            //     return this.orgList.filter(item=>item.value == this.formItem.org_id).map(item=>{
            //         return {
            //             org_id:item.value,
            //             org_name:item.label,
            //         }
            //     });
            // },
        },
        watch:{
            org: {
                handler(newVal, oldVal) {
                    let newList = (newVal||{}).list||[];
                    if(newList.length != 0 && !this.isEdit) {
                        this.orgList = newVal.list
                        this.formItem.org_id = newVal['id'].toString()
                        if(this.formItem.org_id != '') {
                            this.getOrgConfig();
                        }
                    }else{
                        if(!this.isEdit&&oldVal===undefined){
                            this.getOrgSelectorList();
                        }
                    }
                },
                immediate: true,
                deep: true, // 深度监听
            },
        },
        mounted() {
            console.log('mounted ad_org');
            if(this.isEdit) {
                let editInfo = this.$store.getters.apple_edit_info
                console.log('editInfo', editInfo.org_id)
                // 获取编辑状态下的详情
                this.getEditInfo(editInfo);
            }else {
                // let date = new Date(new Date().getTime()-1000*60*60*24);
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                this.formItem.startDate = `${year}-${month}-${day}`;

                this.formItem.buyer_email = this.email;
                this.formItem.buyer_name = this.name;
                // this.getOrgSelectorList();
            }

            document.addEventListener('click', this.handleDocumentClick);
            window.scrollTo(0, 0);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleDocumentClick);
        },
        methods: {
            handleDocumentClick(e){
                // console.log(e);
                this.appPopover = false;
                this.appList = [];
            },
            checkApp(item){
                console.log('checkApp', item);
                this.formItem.app_id = item.value;
                this.formItem.app_name = item.label;
                this.appInput = item.label+'【'+item.value+'】';
                this.appPopover = false;
                this.changeSelect('app_id',item.value);
            },
            removeApp(){
                this.$confirm('修改App，【广告投放位置】【国家或地区】将会被重置', '提示', {
                    closeOnPressEscape:false,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    callback:(action)=>{
                        console.log('action',action,this);
                        if(action=='confirm'){
                            this.formItem.app_id = '';
                            this.formItem.app_name = '';
                            this.appInput = '';
                            this.changeSelect('app_id','');
                            this.resetData('app_id');
                        }

                    },
                });
            },
            appInputChange(){
                this.$nextTick(()=>{
                    this.$refs.orgForm.clearValidate('app_id');
                });
            },
            searchApp(){
                if(this.appInput.length<3){
                    this.appList = [];
                    this.appErrTxt = '输入的名称或ID关键字不可少于三个字';
                }else{
                    this.appErrTxt = '';
                    this.remoteAppLoading = true;
                    this.appPopover = true;
                    this.appList = [];
                    this.$refs.orgForm.clearValidate('app_id');
                    API.getPromotionAppOptions({
                        search:this.appInput,
                        org_id:this.formItem.org_id||'',
                    }).then(res=>{
                        let resData = res.data||[];
                        this.appList = resData.map(item=>{
                            return {
                                value:item.adam_id,
                                label:item.app_name,
                            }
                        });
                        this.remoteAppLoading = false;
                    },err=>{
                        console.log('getOrgSelectorList err',err);
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.appList = [];
                        this.remoteAppLoading = false;
                    });
                }
            },
            getEditInfo(data){
                this.editLoading = true;
                this.$emit('postresult', {loading: true, dialog: false, success: false,});
                API.getCampaignInfo({
                    org_id:data.org_id,
                    campaign_id:data.campaign_id,
                }).then(res=>{
                    console.log('editCampaign',res);
                    this.editLoading = false;

                    let resData = res.data||{};
                    this.formItem.org_id = resData.org_id;
                    this.formItem.campaign_id = resData.campaign_id;
                    this.formItem.app_id = resData.adam_id;
                    this.formItem.app_name = resData.app_name;
                    this.appInput = resData.app_name+'【'+resData.adam_id+'】';
                    this.appList = [{
                        value:resData.adam_id,
                        label:resData.app_name,
                    }];
                    this.orgList = [{
                        value:resData.org_id,
                        label:resData.org_name,
                    }];

                    this.formItem.supply_source = resData.supply_source;
                    this.getPromotionAppEligibility().then(()=>{
                        this.updateEligibility();
                        this.formItem.countries_or_regions = Object.keys(resData.countries_or_regions);
                    });

                    this.formItem.daily_budget = resData.daily_budget;
                    this.getOrgConfig();
                    this.formItem.campaign_name = resData.campaign_name;

                    let startTime = resData.start_time||'';
                    let endTime = resData.end_time||'';

                    this.startEndDateType = endTime?'2':'1';
                    this.formItem.startDate = startTime.split(' ')[0]||'';
                    this.formItem.startTime = startTime.split(' ')[1]||'';
                    if(endTime){
                        this.formItem.endDate = endTime.split(' ')[0]||'';
                        this.formItem.endTime = endTime.split(' ')[1]||'';
                    }

                    this.formItem.client_name = resData.client_name;
                    this.formItem.order_number = resData.order_number;
                    this.formItem.buyer_name = resData.buyer_name;
                    this.formItem.buyer_email = resData.buyer_email;
                    this.formItem.billing_contact_email = resData.billing_contact_email||'';
                    this.getCampaignDailyBudgetConfig();
                    this.$emit('postresult', {loading: false, dialog: false, success: false,});

                },err=>{
                    console.log('editCampaign err',err);
                    this.editLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$emit('postresult', {loading: false, dialog: false, success: false,});
                })
            },
            changeSelect(type,val){
                console.log('changeSelect',type,val);

                if(!this.oldSelectVal[type]){
                    this.oldSelectVal[type] = this.formItem[type];
                    if(type=='app_id'){
                        this.resetData(type);
                        this.$emit('postresult', {loading: false, dialog: !!this.formItem.app_id, success: false})
                    }else if(type=='org_id'){
                        this.getCampaignDailyBudgetConfig();
                        // this.getOrgConfig();
                        let orgItem = this.orgList.find(item=>item.value==val)||{};
                        this.orgName = orgItem.label||'';
                        console.log('val1', val, this.orgList)
                        this.$emit('postOrg', {
                            id: val ? val : '',
                            list: this.orgList
                        })
                        this.$emit('postresult', {loading: false, dialog: !!this.formItem.app_id, success: false})
                    }
                }else if(val!=this.oldSelectVal[type]){
                    if(type=='org_id'&&this.formItem.app_id){
                        this.$confirm('修改广告系列组，已填写的内容将会被清空', '提示', {
                            closeOnPressEscape:false,
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                        }).then(() => {
                            console.log('resetData',type);
                            this.oldSelectVal.app_id = '';
                            this.resetData('org_id');
                            /*手动隐藏下拉筛选框*/
                            this.$refs['select_'+type].blur();
                            this.oldSelectVal[type] = this.formItem[type];
                            this.appInput = '';
                            this.formItem.app_id = '';
                            this.formItem.app_name = '';
                            this.formItem.daily_budget = '';
                            this.avgCampaignDailyBudget = '';
                            this.getOrgConfig();
                            this.getCampaignDailyBudgetConfig();

                            console.log('修改1', val, this.orgList)
                            this.$emit('postOrg', {
                                id: val ? val : '',
                                list: this.orgList
                            })

                        }).catch(() => {
                            this.formItem[type] = this.oldSelectVal[type];
                            console.log('修改2 取消', val, this.oldSelectVal[type], this.orgList)
                            this.$emit('postOrg', {
                                id: this.oldSelectVal[type] ? this.oldSelectVal[type] : '',
                                list: this.orgList
                            })
                            /*手动隐藏下拉筛选框*/
                            this.$refs['select_'+type].blur();

                            
                        });
                    }else if(type=='app_id'&&val){
                        this.$confirm('修改App，【广告投放位置】【国家或地区】将会被重置', '提示', {
                            closeOnPressEscape:false,
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                        }).then(() => {
                            console.log('resetData',type);
                            this.formItem.app_id = val;
                            this.oldSelectVal.app_id = val;
                            this.resetData('app_id');
                            /*手动隐藏下拉筛选框*/
                            this.$refs['select_'+type].blur();
                            let orgItem = this.orgList.find(item=>item.value==this.formItem.org_id)||{};
                            this.orgName = orgItem.label||'';
                            this.oldSelectVal[type] = this.formItem[type];
                        }).catch(() => {
                            this.formItem[type] = this.oldSelectVal[type];
                            /*手动隐藏下拉筛选框*/
                            this.$refs['select_'+type].blur();
                        });
                    }else{
                        this.oldSelectVal[type] = this.formItem[type];
                        if(type=='org_id'&&val){
                            console.log('val2', val, this.orgList)
                            this.formItem.daily_budget = '';
                            this.$emit('postOrg', {
                                id: val ? val : '',
                                list: this.orgList
                            })
                            this.getOrgConfig();
                            this.getCampaignDailyBudgetConfig();
                        }
                    }
                }else{
                    this.oldSelectVal[type] = this.formItem[type];
                }
            },
            resetData(type){
                if(type=='org_id'){
                    this.formItem.app_id = '';
                    this.avgCampaignDailyBudget = 0;
                    this.oldSelectVal.app_id = '';
                    this.resetData('app_id');
                }else if(type=='app_id'){
                    this.getPromotionAppEligibility();
                    if(this.formItem.app_id){
                        let appItem = this.appList.find(item=>item.value==this.formItem.app_id);
                        this.formItem.order_number = this.formItem.app_id;
                        this.formItem.client_name = appItem?appItem.label:'';
                    }
                    this.formItem.supply_source = '';
                    this.formItem.countries_or_regions = [];
                    this.countryList = [];
                    this.appList = [];
                    this.formItem.negative_keyword = [];
                }
            },
            getOrgConfig(){
                API.getOrgConfig({
                    org_id:this.formItem.org_id,
                }).then(res=>{
                    let resData = res.data||{};
                    this.orgConfig.currency = resData.currency;
                    this.orgConfig.invoicing_options = resData.invoicing_options;

                    this.formItem.time_zone = resData.time_zone;

                    /* 编辑的时候拿getEditInfo接口里的值，此处仅添加时需要赋值 */
                    if(!this.isEdit){
                        this.formItem.billing_contact_email = resData.billing_contact_email||'';
                    }
                })
            },
            getCampaignDailyBudgetConfig(){
                API.getCampaignDailyBudgetConfig({
                    org_id:this.formItem.org_id,
                }).then(res=>{
                    let resData = res.data||{};
                    this.avgCampaignDailyBudget = +resData.avg_campaign_daily_budget;
                })
            },
            getPromotionAppEligibility(){
                let appId = this.formItem.app_id;
                if(!appId) {
                    this.supplySourceOptions.forEach(item=>{
                        item.disabled = true;
                        item.popTip = '请先选择APP';
                    });
                    return false;
                }

                this.appEligibilityLoading = true;
                return API.getPromotionAppEligibility({
                    adam_id:this.formItem.app_id,
                    org_id:this.formItem.org_id,
                }).then(res=>{
                    console.log('getPromotionAppEligibility',res);

                    let resData = res.data||{};
                    this.appEligibility = resData;
                    this.supplySourceOptions.forEach(item=>{
                           let actionItem = resData[item.name];
                           item.title = actionItem.name;
                           item.desc = actionItem.note;
                           item.disabled = actionItem.state!='ELIGIBLE';
                           item.popTip = actionItem.state=='ELIGIBLE'?'':'您选择的App暂不可投放该位置';
                       });
                    this.appEligibilityLoading = false;
                },err=>{
                    console.log('getPromotionAppEligibility err',err);
                    this.appEligibilityLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'请求失败');
                })
            },
            getOrgSelectorList(){
                this.remoteOrgLoading = true;
                API.getOrgSelectorList({
                    source_page:this.cur_tab_page,
                    search:'',
                }).then(res=>{
                    let resData = res.data||[];
                    let resultList = resData.map(item=>{
                        return {
                            value:item.org_id,
                            label:item.org_name,
                        }
                    });
                    this.$emit('postOrg', {
                        id: '',
                        list: resultList
                    })
                    this.remoteOrgLoading = false;
                },err=>{
                    console.log('getOrgSelectorList err',err);
                    // this.orgList = [];
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$emit('postOrg', {
                        id: '',
                        list: []
                    })
                    this.remoteOrgLoading = false;
                })
            },
            remoteAppMethod(query){
                if (query.length >3) {
                    this.remoteAppLoading = true;
                    API.getPromotionAppOptions({
                        search:query,
                        org_id:this.formItem.org_id||'',
                    }).then(res=>{
                        let resData = res.data||[];
                        this.appList = resData.map(item=>{
                            return {
                                value:item.adam_id,
                                label:item.app_name,
                            }
                        });
                        this.remoteAppLoading = false;
                    },err=>{
                        console.log('getOrgSelectorList err',err);
                        this.appList = [];
                        this.remoteAppLoading = false;
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                    })

                } else {
                    this.appList = [];
                }
            },
            changeSupplySource(val){
                console.log('changeSupplySource',val);

                if(this.formItem.supply_source=='APPSTORE_SEARCH_RESULTS'&&this.formItem.negative_keyword.length>0){
                    this.$confirm('修改投放位置，已添加的否定关键词将会被清空?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.formItem.negative_keyword = [];
                        this.formItem.supply_source = val;
                        this.updateEligibility();
                    }).catch(() => {

                    });

                }else{
                    this.formItem.supply_source = val;
                    this.updateEligibility();
                }

                this.$refs.orgForm.validateField('supply_source');
            },
            updateEligibility(){
                let supply_source = this.formItem.supply_source;
                if(!supply_source) return;
                let actionItem = this.appEligibility[supply_source]||{};
                let listObj = actionItem.country_or_region||{};
                let keyList = Object.keys(listObj)||[];
                this.countryList = keyList.map(item=>{
                    return {
                        label:listObj[item],
                        value:item,
                    }
                });
                this.formItem.countries_or_regions = [];
            },
            handleDailyBudgetInput(val,limit=2){
                let rval = val.replace(/[^0-9\d.]/g, ''); //保留数字

                // rval = rval.replace(/^00/, "0."); //开头不能有两个0
                rval = rval.replace(/^\./g, "0."); //开头为小数点转换为0.
                rval = rval.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
                rval = rval.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
                /^0\d+/.test(rval) ? rval = rval.slice(1) : ''; //两位以上数字开头不能为0
                // rval = rval.replace(/[^0-9\d.]/g, '').replace(/^(-)?0(?!\.)/g, '')
                const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
                const reg = new RegExp(str)
                if (limit === 0) {
                    // 不需要小数点
                    rval = rval.replace(reg, '$1')
                } else {
                    // 通过正则保留小数点后指定的位数
                    rval = rval.replace(reg, '$1.$2')
                }
                this.formItem.daily_budget = rval;
            },
            showNegativeKeywordModal(){
                this.$refs.negativeKeywordModal.showModal();
            },
            clearNegativeKeyword(){
                this.formItem.negative_keyword = [];
            },
            saveNegativeKeyword(list){
                this.formItem.negative_keyword = [...list];
            },
            handleSubmit(name, type,toGroup){
                this.$refs.orgForm.validate((valid) => {
                    if(valid){
                        let reqData = {
                            org_id:this.formItem.org_id,
                            supply_source:this.formItem.supply_source,
                            adam_id:this.formItem.app_id,
                            countries_or_regions:this.formItem.countries_or_regions,
                            campaign_name:this.formItem.campaign_name,
                            daily_budget:this.formItem.daily_budget,
                            start_time:this.formItem.startDate+' '+this.formItem.startTime,
                            time_zone:this.formItem.time_zone,
                        };

                        /* 搜索结果：有否定关键词，其他选项没有 */
                        if(this.formItem.supply_source=='APPSTORE_SEARCH_RESULTS'&&!this.isEdit){
                            let negativeKeyword = this.formItem.negative_keyword.map(item=>{
                                return {
                                    text:item.key_word_text,
                                    match_type:item.match_type=='精准匹配'?'EXACT':(item.match_type=='广泛匹配'?'BROAD':''),
                                }
                            });
                            reqData.negative_keyword = JSON.stringify(negativeKeyword);
                        }

                        if(this.startEndDateType=='2'){
                            reqData.end_time = this.formItem.endDate+' '+this.formItem.endTime;
                        }else if(this.startEndDateType=='1'){
                            reqData.end_time = '';
                        }
                        if(this.orgConfig.invoicing_options){
                            reqData.client_name = this.formItem.client_name;
                            reqData.order_number = this.formItem.order_number;
                            reqData.buyer_name = this.formItem.buyer_name;
                            reqData.buyer_email = this.formItem.buyer_email;
                            reqData.billing_contact_email = this.formItem.billing_contact_email;
                        }


                        this.$emit('postresult', {loading: true, dialog: false, success: false, type:type})

                        let currency_time = new Date().valueOf();
                        let current_name = `${this.apple_create_type}_${currency_time}`;
                        if(this.apple_create_type == 'editOrg') {
                            reqData.campaign_id = this.formItem.campaign_id;

                            this.dialogVisible = true;
                            this.dialogTypeTitle = '编辑广告系列，正在处理…';

                            API.editCampaign(reqData).then(res=>{
                                console.log('editCampaign',res);
                                // 处理多个个请求中 关闭
                                this.dialogVisible = false
                                this.dialogTypeTitle = ''

                                // 单个请求成功
                                let flag_single_post_html = get_flag_suc_html(res['info'], '')
                                let current_tip = this.$notify({
                                    showClose: false,
                                    duration: 5000,
                                    dangerouslyUseHTMLString: true,
                                    message: flag_single_post_html
                                });

                                this.$emit('postresult', {loading: false, dialog: false, success: true,type:'editOrg'})

                            },err=>{
                                console.log('editCampaign err',err);
                                let resultData = err.data||{};

                                // 处理多个个请求中 关闭
                                this.dialogVisible = false
                                this.dialogTypeTitle = ''
                                if (err.code == '403') {
                                    this.$confirm(err.info, '提示', {
                                        confirmButtonText: '刷新',
                                        type: 'warning',
                                        showClose: false,
                                        closeOnClickModal: false,
                                        closeOnPressEscape: false
                                    }).then(() => {
                                        window.location.reload()
                                    }).catch(() => {
                                    });
                                    return
                                }



                                // 处理多个错误结果 info, msg,errList,negativeErrList,current_name
                                let flag_mul_err_html = get_create_ad_err_html(err['info'], resultData['msg'],[],[],current_name );

                                let current_tip = this.$notify({
                                    showClose: false,
                                    duration: 0,
                                    dangerouslyUseHTMLString: true,
                                    message: flag_mul_err_html
                                });
                                this.$store.commit('apple/ADD_NOTIFY', {
                                    id: `${current_name}_close`,
                                    value: current_tip,
                                });

                                this.$emit('postresult', {loading: false, dialog: false, success: false,type:type})
                            })
                        }else {
                            this.dialogVisible = true;
                            this.dialogTypeTitle = '创建广告系列，正在处理…';

                            API[name](reqData, {
                                timeout: 120 * 1000,
                            }).then(res => {
                                console.log('提交', res)
                                // 处理多个个请求中 关闭
                                this.dialogVisible = false
                                this.dialogTypeTitle = ''

                                // 单个请求成功
                                let flag_single_post_html = get_flag_suc_html(res['info'], '')
                                let current_tip = this.$notify({
                                    showClose: false,
                                    duration: 5000,
                                    dangerouslyUseHTMLString: true,
                                    message: flag_single_post_html
                                });

                                if(toGroup){
                                    let resData = res.data||{};
                                    let campData = resData.data||{};
                                    let campaignList = [{
                                        campaign_id:campData.campaign_id,
                                        campaign_name:campData.campaign_name,
                                    }];

                                    this.$emit('postresult', {loading: false, dialog: false, success: true,type:type,toGroup:!!toGroup,campaign_list:{type:'campaign',list:campaignList}})
                                }else{
                                    this.$emit('postresult', {loading: false, dialog: false, success: true,type:type})
                                }
                            }, err => {
                                let resultData = err.data||{};
                                // 处理多个个请求中 关闭
                                this.dialogVisible = false
                                this.dialogTypeTitle = ''
                                if (err.code == '403') {
                                    this.$confirm(err.info, '提示', {
                                        confirmButtonText: '刷新',
                                        type: 'warning',
                                        showClose: false,
                                        closeOnClickModal: false,
                                        closeOnPressEscape: false
                                    }).then(() => {
                                        window.location.reload()
                                    }).catch(() => {
                                    });
                                    return
                                }

                                let campData = resultData.data||{};
                                let isCreateCampSuccess = campData.campaign_id&&campData.campaign_name;

                                let keywordErrList = resultData.keyword_err_list||[];
                                let negativeKeywordErrList = resultData.negative_keyword_err_list||[];


                                // 处理多个错误结果 info, msg,errList,negativeErrList,current_name
                                let flag_mul_err_html = get_create_ad_err_html(err['info'], resultData['msg'], keywordErrList, negativeKeywordErrList,current_name );

                                let current_tip = this.$notify({
                                    showClose: false,
                                    duration: 0,
                                    dangerouslyUseHTMLString: true,
                                    message: flag_mul_err_html
                                });
                                this.$store.commit('apple/ADD_NOTIFY', {
                                    id: `${current_name}_close`,
                                    value: current_tip,
                                });


                                if(toGroup&&isCreateCampSuccess){
                                    let campaignList = [{
                                        campaign_id:campData.campaign_id,
                                        campaign_name:campData.campaign_name,
                                    }];
                                    this.$emit('postresult', {loading: false, dialog: false, success: true,type:type,toGroup:!!toGroup,campaign_list:{type:'campaign',list:campaignList}})
                                }else{
                                    this.$emit('postresult', {loading: false, dialog: false, success: false,type:type})
                                }
                            })
                        }
                    }else{
                        console.log('error submit!!');
                        this.$message.error('表单数据填写有误，请检查后重新提交');
                        return false;
                    }
                });
            },
        },

    }
    
</script>
<style lang="scss" scoped>
    .width80{
        width: 80px;
    }
    .width400 {
        width: 400px;
    }
    .normal-text{
        font-size: 12px;
        color: #606266;
    }

    .apple_org ::v-deep .el-form-item__label{
        text-indent: 20px;
    }
    .apple_org ::v-deep .invoicing_options .el-form-item__label{
        text-indent: 10px;
    }

    .create_list{
        background-color: #fff;
        padding: 10px;
        margin-bottom: 20px;
        .create_title{
            font-size: 14px;
            padding-bottom: 10px;
            padding-left: 20px;
        }
        .create_item{
            display: flex;
            align-items: center;
            padding-bottom: 30px;
            .create_label{
                flex: 0 0 200px;
                .star{
                    color: #ff0000;
                    font-size: 16px;
                    display: inline-block;
                    vertical-align: middle;
                }
                .create_label_text{
                    font-size: 14px;
                    display: inline-block;
                }
            }
            .create_action{
                flex: 0 0 300px;
                position: relative;
                .create_err_bottom{
                    color: #ff0000;
                    position: absolute;
                }
            }
            .create_err_right{
                flex: auto;
                display: inline-block;
                color: #ff0000;
            }
            .questions {
                width: 12px;
                height: 12px;
                line-height: 14px;
                text-align: center;
                border-radius: 10px;
                background-color: #333;
                color: #fff;
                font-size: 12px;
                display: inline-block;
                margin-left: 2px;
                cursor: pointer;
            }
            .ad_name_flex{
                display: flex;
                align-items:center;
                .num_length{
                    padding-left:8px;
                    flex: 0 0 60px;
                }
            }
        }

        .daily-budget-tips-text{
            position: absolute;
            left: 420px;
            right: 0;
            line-height: 16px;
            top: 8px;
        }
    }

    .app-reference{
        position: absolute;
        display: block;
        width: 10px;
        height: 1px;
        top: 30px;
        z-index: 3;
    }
    .remove-app-btn{
        display: block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 12px;
        position: absolute;
        cursor: pointer;
        top: 6px;
        left: 295px;
        z-index: 1;
        &:hover{
            color: #333;
            background-color: #fff;
        }


    }
</style>
